import { Button, Dialog, DialogActions } from "@mui/material";
import React, { useEffect } from "react";
import { useLocales } from "src/locales";
import { useTheme } from "@mui/material/styles";
import useLocalStorage from "src/hooks/useLocalStorage";

const IframePaymentComponent = ({
  open,
  handleCompleteOrder,
  placeOrderUrl,
  handleCloseIframe,
}) => {
  const { translate } = useLocales();
  const theme = useTheme();

  useEffect(() => {
    // Listen for messages from the iframe
    const receiveMessage = (event) => {
      // Assuming the iframe sends an object with a 'finish-order' of 'add-card' property
      if (event.data) {
        const receivedId = event.data["finish-order"] || event.data["add-card"];
        if (receivedId) {
          handleCompleteOrder(receivedId);
        }
      }
    };

    window.addEventListener("message", receiveMessage);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("message", receiveMessage);
    };
  }, []);

  return (
    <Dialog
      open={open}
      fullScreen
      PaperProps={{
        style: {
          backgroundColor: "white",
          width: "110%",
          marginLeft: "-5%",
          marginRight: "-5%",
        },
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <iframe
        src={placeOrderUrl}
        title="Embedded Content"
        style={{ width: "100%", height: "100%" }} // Customize iframe dimensions
      />
      <DialogActions>
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            handleCloseIframe();
          }}
          sx={{ backgroundColor: theme.palette.error.main }}
        >
          {translate("checkout.payment.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IframePaymentComponent;
